<template>
  <div class="logo-tile" :class="size">
    <Icon v-if="tile.logoIcon" :name="tile.logoIcon" size="large" />
    <img v-else-if="tile.logo" :src="tile.logo" :alt="alt" class="logo-image" :class="{ wide: tile.wide }" />
  </div>
</template>

<script setup lang="ts">
import { Icon } from '@tallo/design-system';

import { IntegrationTile } from './integrations.config';

withDefaults(defineProps<{ tile: IntegrationTile; size?: 'medium' | 'large'; alt?: string }>(), {
  size: 'medium',
  alt: '',
});
</script>

<style scoped lang="scss">
// Brand marks sit on a white tile so each logo keeps its own colours in both themes.
.logo-tile {
  display: flex;
  // A fixed width still shrinks as a flex child, which squashed the mark to a sliver on narrow screens.
  flex: 0 0 auto;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--t-color-border-secondary);
  border-radius: var(--t-border-radius-sm);
  background-color: var(--t-color-neutral-white);

  &.medium {
    width: 3rem;
    height: 3rem;
  }

  &.large {
    width: 3.5rem;
    height: 3.5rem;
    border-radius: var(--t-border-radius-md);
  }
}

// Brand marks arrive at wildly different aspect ratios and paddings, so they are fitted, not stretched.
.logo-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: var(--t-spacing-xs);
}

// A wordmark is only a few pixels tall once fitted, so it drops the vertical padding but keeps a
// little on the sides so it does not run into the tile's edge.
.logo-image.wide {
  padding: 0 var(--t-spacing-xs);
}
</style>
